//import CoolenMoveUrl from "@/pcomponents/common/content/coolen/study/func/move_url";
import strFunc from "@/lib/lyg/string";
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";

class CoolenMoveUrl
{
  static go_to_study_url(inData: any){
    let opt_obj = {
      token_id: localStorage.getItem('intoyou_token'),
      coolen_study_par_id: "study_list",//mtextbook_list
      detail_info: null,
      detail_use_info:null,
      study_is_save:"1",
      is_new_window:"",
      back_sort: "web_student",//web,popup
      title:"",
      ...inData
    };
    let this_obj=this;
    let detail_info = opt_obj.detail_info;
    let study_par_seq = "";
    if (detail_info["a_par_id"] == "contents_book") {
      study_par_seq = detail_info["a_par_seq"];
    }
    let study_list_pri_val = detail_info["a_title_seq"] + "," + detail_info["a_seq"];
    if(opt_obj.coolen_study_par_id=="mtextbook_list"){
      study_list_pri_val = detail_info["a_book_seq"] + "," + detail_info["a_seq"];
    }
    if (strFunc.is_empty(study_par_seq)) {
      alert("학습 자료가 없습니다.");
      return false;
    }

    let coolen_study_sort="word2";
    if(!strFunc.is_empty(opt_obj.detail_use_info)){
      coolen_study_sort="word";
    }

    let form_json_data: any = {
      s_uid: study_par_seq
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/coolen/coolen_con_book/list', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (response.data["data"]["info_arr"].length == 0) {
            alert("학습 자료가 없습니다..");
          } else {
            let cont_book_info = response.data["data"]["info_arr"][0];
            let s_cont_book_like_after = "";
            let s_cont_book_like_arr = cont_book_info.cont_book.split(" ");
            if (s_cont_book_like_arr.length > 0) {
              s_cont_book_like_after = s_cont_book_like_arr[s_cont_book_like_arr.length - 1];
            }

            this_obj.go_to_url({
              token_id: opt_obj.token_id,
              coolen_study_par_id: opt_obj.coolen_study_par_id,
              coolen_study_par_seq: study_list_pri_val,
              coolen_study_sort: coolen_study_sort,
              study_is_save:opt_obj.study_is_save,
              is_new_window:opt_obj.is_new_window,
              back_sort: opt_obj.back_sort,
              s_book_no:cont_book_info.book_no,
              s_cont_book_like_after:s_cont_book_like_after,
              s_cont_unit:cont_book_info.cont_unit,
              title:opt_obj.title
            });
          }
        } else {

        }
      });
  }

  static go_to_url(inData: any) {
    let opt_obj = {
      token_id: localStorage.getItem('intoyou_token'),
      coolen_study_par_id: "study_list",//mtextbook_list
      coolen_study_par_seq: "",
      coolen_study_sort: "word2",
      study_is_save:"1",
      is_new_window:"",
      back_sort: "web_student",//web,popup,web_student
      s_book_no:"",
      s_cont_book_like_after:"",
      s_cont_unit:"",
      title:"",
      ...inData
    };

    let get_data_str = "?token_id=" + opt_obj.token_id;
    get_data_str += "&coolen_back_sort="+opt_obj.back_sort;
    get_data_str += "&coolen_study_sort="+opt_obj.coolen_study_sort;
    get_data_str += "&coolen_study_par_id="+opt_obj.coolen_study_par_id;
    get_data_str += "&coolen_study_par_seq=" + opt_obj.coolen_study_par_seq;
    get_data_str += "&coolen_study_is_save=" + opt_obj.study_is_save;
    get_data_str += "&s_book_no=" + opt_obj.s_book_no;
    get_data_str += "&s_cont_book_like_after=" + opt_obj.s_cont_book_like_after;
    get_data_str += "&s_cont_unit=" + opt_obj.s_cont_unit;
    get_data_str += "&title=" + opt_obj.title;

    let move_url=process.env.REACT_APP_API_URL + "/home/cool_en/login" + get_data_str;
    if (opt_obj.is_new_window === "1") {
      window.open(move_url, "_blank");
    } else {
      location.href = move_url;
    }
  };
}
export default CoolenMoveUrl;